/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ChessPawnIconConfig = {
  name: 'ChessPawnIcon',
  height: 512,
  width: 320,
  svgPath: 'M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ChessPawnIconConfig);
//# sourceMappingURL=chess-pawn-icon.js.map